export const T = {
  en_GB: {
    tableHeaderName: "Name",
    tableHeaderIsin: "ISIN",
    tableHeaderType: "Type",
    tableHeaderSuitable: "Suitable",
    tableHeaderAmount: "Amount",
    tableHeaderWeight: "Weight",
    tableHeaderActions: "Actions",
    unknown: "Unknown",
    suitable: "Suitable",
    notSuitable: "Not suitable",
    estimated: "Estimated",
    units: "Units",
    editProductAmount: "Edit Product Amount",
    deleteProduct: "Delete Product",
    totalProducts: (count: number) => `Total (${count} products)`,
    belowMinBuy: "Below minimum",
    minBuyTooltip: (min: string) =>
      `The amount for this product is below its minimum buy of ${min}. Increase the amount to at least the minimum or remove the product.`,
    tableHeaderExisting: "Existing",
    tableHeaderChange: "Change",
    notAvailableForPurchase:
      "This product is not available for new purchases. You can keep or reduce the current holding.",
    // Review #3 — neutral on purpose: this also fires for an agreement
    // follow-up's currently funded savings-plan line, where "nothing of it
    // is held yet" would be a materially wrong claim about money the client
    // has actually invested.
    lockedRemoveOnly:
      "This product can no longer be purchased in this flow. It can only be removed from the portfolio.",
    newProduct: "New",
    newWrapperAccountBadge: (wrapper: string) => `New ${wrapper} account`,
    // QL-17 — only the first "{wrapper}" was ever filled (single `.replace`);
    // the second stays literal so the text is byte-for-byte what it was.
    newWrapperAccountTooltip: (wrapper: string) =>
      `This instrument requires a ${wrapper} wrapper, which the current account does not provide. Completing this flow will open a new pending {wrapper} account for it.`,
    unmatchableHoldingTooltip:
      "This holding is not in the flow's product collection, so it cannot be bought or adjusted here. It can only be kept or sold (fully or partially) on completion.",
    kept: "Kept",
    willBeSoldAmount: (sold: string, total: string) => `Will be sold — ${sold} of ${total}`,
    tableHeaderDirection: "Direction",
    directionBuyTooltip: "Will be bought on completion",
    directionSellTooltip: "Will be sold on completion",
    directionKeepTooltip: "Kept unchanged on completion",
    editSellAmount: "Edit sell amount",
    adjustHoldingTooltip: "Adjust holding — buy, keep or sell",
    directionSwitchTooltip:
      "Part of this holding will be sold and the proceeds invested in the switch targets below.",
    switchAction: "Switch into other products",
    switchBlockedDeltaTooltip:
      "This holding has a buy/sell change — reset its target (or clear its sell) before adding a switch.",
    switchTargetLockedTooltip:
      "This holding has switch instructions — its target is locked at the existing amount. Remove the switch pairs to edit it.",
    switchSellBlockedTooltip:
      "This holding has switch instructions — remove its switch pairs before selling it.",
    switchViewAction: "View switch instructions",
  },
  nb_NO: {
    tableHeaderName: "Navn",
    tableHeaderIsin: "ISIN",
    tableHeaderType: "Type",
    tableHeaderSuitable: "Egnet",
    tableHeaderAmount: "Beløp",
    tableHeaderWeight: "Vekt",
    tableHeaderActions: "Handlinger",
    unknown: "Ukjent",
    suitable: "Egnet",
    notSuitable: "Ikke egnet",
    estimated: "Estimert",
    units: "Andeler",
    editProductAmount: "Rediger produktbeløp",
    deleteProduct: "Slett produkt",
    totalProducts: (count: number) => `Totalt (${count} produkter)`,
    belowMinBuy: "Under minimum",
    minBuyTooltip: (min: string) =>
      `Beløpet for dette produktet er under minimumskjøpet på ${min}. Øk beløpet til minst minimum eller fjern produktet.`,
    tableHeaderExisting: "Eksisterende",
    tableHeaderChange: "Endring",
    notAvailableForPurchase:
      "Dette produktet er ikke tilgjengelig for nye kjøp. Du kan beholde eller redusere gjeldende beholdning.",
    lockedRemoveOnly:
      "Dette produktet kan ikke lenger kjøpes i denne flyten. Det kan bare fjernes fra porteføljen.",
    newProduct: "Ny",
    newWrapperAccountBadge: (wrapper: string) => `Ny ${wrapper}-konto`,
    newWrapperAccountTooltip: (wrapper: string) =>
      `Dette instrumentet krever en ${wrapper}-innpakning, som gjeldende konto ikke tilbyr. Fullføring av denne flyten vil opprette en ny ventende {wrapper}-konto for det.`,
    unmatchableHoldingTooltip:
      "Denne beholdningen er ikke i flytens produktsamling og kan derfor ikke kjøpes eller justeres her. Den kan bare beholdes eller selges (helt eller delvis) ved fullføring.",
    kept: "Beholdes",
    willBeSoldAmount: (sold: string, total: string) => `Vil bli solgt — ${sold} av ${total}`,
    tableHeaderDirection: "Retning",
    directionBuyTooltip: "Vil bli kjøpt ved fullføring",
    directionSellTooltip: "Vil bli solgt ved fullføring",
    directionKeepTooltip: "Beholdes uendret ved fullføring",
    editSellAmount: "Rediger salgsbeløp",
    adjustHoldingTooltip: "Juster beholdning — kjøp, behold eller selg",
    directionSwitchTooltip:
      "En del av denne beholdningen selges og provenyet investeres i byttemålene nedenfor.",
    switchAction: "Bytt til andre produkter",
    switchBlockedDeltaTooltip:
      "Denne beholdningen har en kjøps-/salgsendring — tilbakestill målet (eller fjern salget) før du legger til et bytte.",
    switchTargetLockedTooltip:
      "Denne beholdningen har bytteinstruksjoner — målet er låst til eksisterende beløp. Fjern bytteparene for å redigere.",
    switchSellBlockedTooltip:
      "Denne beholdningen har bytteinstruksjoner — fjern bytteparene før du selger den.",
    switchViewAction: "Se bytteinstruksjoner",
  },
} as const;
